// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoSpinner_wrapper__GibNh","spinner":"LogoSpinner_spinner__dYThv","spin":"LogoSpinner_spin__YGb6j","message":"LogoSpinner_message__A+mlU"};